import "./flickity"; import "./index.js"; import "./turbolinks.scss"
